<!--Web View-->
<div class="container-fluid webView" style="padding: 0px 30px;">
    <!-- Header -->
    <div class="col-12 col-sm-12 bgWhite webView" style="padding: 15px 0px 0px 0px">
        <div class="col-5 col-sm-5 " style="padding: 0px;display: inline-block;">
            <h3 class="lblHeader newHeader" style="display: inline-block;">
                HSN / SAC
            </h3>
        <span style="float: right;">
            <span class="btn orangeButton brdrRadius3" (click)="open(mymodal,0)" title="Add New HSN"
                style="position: relative; top: 6px; cursor: pointer; bottom: 5px; font-size: 11px;">
                <i class="zmdi zmdi-plus" aria-hidden="true" style="font-size: 19px; vertical-align: sub;"></i>
            </span>
        </span>
    </div> 
        <div class="col-7 col-sm-7" style="padding: 0px;text-align: right;display: inline-block;">
            <div  class="com-md-3 col-lg-3" style="display: inline-block; text-align: right; padding: 0px;" >
                <span class="darkBlueButton brdrRadius3" style="font-size: 13px; display: inline-block; padding: 5px 12px 6px !important;" (click)="backBtn()">
                    <i class="fa fa-chevron-left" style="margin-right: 3px;"></i> Return to Inventory
                </span>
            </div>
        </div>
    </div>

    <!-- Body -->
    <div class="row marginZero">
        <div class="col-md-12" style="padding: 0px;">
            <!-- left -->
            <div class="col-md-12 mainCardHeader" style="display: inline-block;overflow: auto;">
                <div class="col-md-5 col-xs-12 col-sm-12 " style="padding: 0px;">
                    <div id="divScrID" class="col-md-12" style="margin-top: 15px; padding: 0px;">
                        <div *ngFor="let s of HSNSACList let i = index"  style="padding: 10px 15px; margin-bottom: 10px;color: #e88421; background: white;border-radius: 3px !important;border: 1px solid;" class="col-12 col-sm-12 {{changeColor(i % 7)}}"> 
                            <div class="row">                                     
                                <div class="col-md-8 font13" style="padding: 0px 0px 5px 15px;cursor: pointer;">
                                    <span>{{s.H}}</span> (<span>{{s.Per}}%</span>)                     
                                </div>       
                                <div class="col-md-4 font13" style="text-align: right;">
                                    <div class="lableBtnOrange" style="margin-right: 10px;display: inline-block;cursor: pointer;" title="Edit" (click)="open(mymodal,s.HID)">
                                        <i class="fa fa-pencil" aria-hidden="true"></i>
                                    </div>
                                    <div class="lableBtnOrange" style="display: inline-block;cursor: pointer;"
                                        title="Delete" (click)="deletehsn(i)">
                                        <i class="fa fa-trash"></i>
                                    </div>
                                </div>
                                <div class="col-md-8 font12" style="display: inline-block;color: #444;">
                                    <span>{{s.C}}</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="bgWhite" style="padding-top: 15px;" *ngIf="HSNSACList.length == 0">
                        <div class="nrf brdrRadius3" style="cursor: pointer;" (click)="open(mymodal,0)">
                            Click here to add a HSN/SAC.
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!--Mobile View-->
<div class="container-fluid mobView" style="padding: 0px 10px;">
    <!-- Header -->
    <div class="col-12 col-sm-12 bgWhite mobView" style="padding: 10px;padding-bottom: 0;">
        <div class="col-8 col-sm-8" style="padding: 0px;display: inline-block;">
            <span style="font-size: 20px; margin-right: 10px;" (click)="backBtn()">
                <i class="fa fa-chevron-left"></i>
            </span>
            <h4 style="display: inline-block;">
                HSN / SAC
            </h4>
        </div> 
        <div class="col-4 col-sm-4" style="padding: 0px;text-align: right;display: inline-block;">
            <span style="float: right;">
                <span class="label addOrgBtnM brdrRadius3" (click)="open(mymodal,0)" title="Add New HSN" style="vertical-align: text-top;">
                    <i class="zmdi zmdi-plus" aria-hidden="true" style="font-size: 19px; vertical-align: inherit; margin-right: 8px;"></i> <span>Add</span>
                </span>
            </span>
        </div>
    </div>

        <!-- Body -->
        <div class="row marginZero">
            <div class="col-12 col-sm-12" style="padding: 0px;">
                <!-- left -->
                <div class="col-12 col-sm-12 mainCardHeader" style="padding: 0px;display: inline-block;overflow: auto; ">
                    <div class="col-12 col-xs-12 col-sm-12 " style="padding: 0px;">
                        <div id="divScrID" class="col-sm-12 col-12" style="margin-top: 15px;">
                            <div *ngFor="let s of HSNSACList let i = index"  style="margin-bottom: 10px;" class="col-12 col-sm-12 orngBadgeM"> 
                                <div class="row">                                     
                                    <div class="col-6 col-sm-6 font13" style="padding: 0px 0px 5px 15px;cursor: pointer;font-weight: bold;" >
                                        <span>{{s.H}}</span> (<span>{{s.Per}}%</span>)                     
                                    </div>       
                                    <div class="col-6 col-sm-6 font13" style="text-align: right;">
                                        <div style="border-radius: 50%; margin-right: 15px;display: inline-block;cursor: pointer;" title="Edit" (click)="open(mymodal,s.HID)">
                                            <i class="fa fa-pencil" aria-hidden="true"></i>
                                        </div>
                                        <div style="border-radius: 50%;display: inline-block;cursor: pointer;"
                                            title="Delete" (click)="deletehsn(i)">
                                            <i class="fa fa-trash"></i>
                                        </div>
                                    </div>
                                    <div class="col-sm-8 col-12 font12" style="display: inline-block;color: #444;">
                                        <span>{{s.C}}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
    
                        <div class="bgWhite" style="padding-top: 15px;" *ngIf="HSNSACList.length == 0">
                            <div class="nrf brdrRadius3" style="cursor: pointer;" (click)="open(mymodal,0)">
                                Click here to add a HSN/SAC.
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
</div>

<!--Add HAN/SAC-->
<ng-template #mymodal let-modal>
    <!--Header-->
    <div class="modal-header" style="border-bottom: none;padding-top: 10px;">
        <div class="col-md-12 col-12 col-xs-12">
            <div class="row">
                <div class="col-md-9 col-10 col-xs-10" style="padding-left: 0px;">
                    <h4 class="modal-title"><span id="ApntmntHdr">{{isEditHSN == false ? 'Add HSN/SAC' : 'Edit HSN/SAC'}}</span></h4>
                </div>
                <div class="col-md-3 col-2 col-xs-2" style="padding: 0px;">
                    <i class="closeMdl zmdi zmdi-close" style="float: right; padding: 7px 10px !important;position: relative;top: -4px !important;" 
                    (click)="closeModal()"></i>
                </div>
            </div>
        </div>
    </div>
    <!--Body-->
    <div class="modal-body" style="padding: 0px;">
        <div class="col-md-12" style="padding: 0px 15px 10px 15px;">
            <div class="col-md-3 col-xs-12 col-12 webView" style="padding: 0px 15px 0px 0px;;display: inline-block;">
                <input type="text" [(ngModel)]="HSNSAC.h" class="form-control" maxlength="8" style="font-size: 12px;"
                    placeholder="HSN/SAC" (keypress)="numberOnly($event)">
            </div>
            <div class="col-md-4 col-xs-12 col-12 webView" style="padding: 0px 15px 0px 0px;;display: inline-block;">
                <input type="text" [(ngModel)]="HSNSAC.per" class="form-control" maxlength="5" style="display: inline-block;width: 80%; margin-right: 5px; text-indent: 2px;font-size: 12px; text-align: right;"
                    placeholder="Percentage" appTwoDecimalNumber>
                    <span style="display: inline-block;font-size: 14px;">%</span> 
            </div>

            <!--Mobile view Start-->
            <div class="col-md-3 col-xs-6 col-6 mobView" style="padding: 0px 15px 0px 0px;;display: inline-block;">
                <input type="text" [(ngModel)]="HSNSAC.h" class="form-control" maxlength="8" style="font-size: 12px;"
                    placeholder="HSN/SAC" (keypress)="numberOnly($event)">
            </div>
            <div class="col-md-4 col-xs-6 col-6 mobView" style="padding: 0px 15px 0px 0px;;display: inline-block;">
                <input type="text" [(ngModel)]="HSNSAC.per" class="form-control" maxlength="5" style="display: inline-block;width: 80%; margin-right: 5px; text-indent: 2px;font-size: 12px; text-align: right;"
                    placeholder="Percentage" appTwoDecimalNumber>
                    <span style="display: inline-block;font-size: 14px;">%</span> 
            </div>
            <!--Mobile view End-->

            <div class="col-md-12 col-xs-12 col-12" style="padding: 0px 15px 0px 0px;display: inline-block;">
                <textarea class="form-control brdrColor" rows="2" [(ngModel)]="HSNSAC.c"  style="padding: 7px;font-size: 12px !important; resize: none; margin-top:10px; border:1px solid #ddd;border-radius:5px !important;width: 100%;" maxlength="200"
                        placeholder="Notes" tabindex="1">
               </textarea>
            </div>
        <div class="col-md-12 col-xs-12 col-12" style="display: inline-block;padding: 0px;top: 5px;margin-bottom: 10px;">
            <span class="btn-green brdrRadius3" style="padding: 3px 10px;line-height: 23px;font-size: 14px;"
                (click)="isEditHSN == false ? saveNewHsn(HSNSAC) : EditHsnModel(HSNSAC)">
                <i class="fa fa-check" style="margin-right: 5px;"></i>
                <span>Save</span>
            </span>
        </div>
    </div>
  </div>
</ng-template>